export enum Resources {
  FirstRevision = 'firstRevision',
  ActiveRevision = 'activeRevision',
  ActiveJob = 'activeJob',
  RequestedRevision = 'requestedRevision',
  WorkflowRequest = 'workflowRequest',
  Aberration = 'Aberration',
  TreatmentPlan = 'TreatmentPlan',
  DiagnosticReport = 'DiagnosticReport',
  TherapyPriority = 'TherapyPriority',
  TherapyMatch = 'TherapyMatch',
  ClinicalTrialMatch = 'ClinicalTrialMatch',
  Progression = 'Progression',
  MolecularFinding = 'MolecularFinding',
  QCResult = 'QCResult',
  Opinion = 'Opinion',
  DiagnosticSummary = "DiagnosticSummary",
  ResourceMap = "ResourceMap"
}
